const UPDATE_FILE = `
  mutation updateFile($input: UpdateFileInput){
    updateFile(input: $input){
      result {
        name
        mimetype
        id
        url
        data
        type
        updated
        storeKey
        filename
        location
      }
    }
  }
`;

const DELETE_FILE_BY_ID = `
  mutation deleteFile ($input: DeleteFileInput!){
    deleteFile(input: $input){
      result
    }
  }
`;

const UPLOAD_FILE = `
  mutation uploadFile($input: UploadFileInput!){
    file: uploadFile(input:  $input){
      result {
        name
        mimetype
        id
        url
        data
        type
        updated
        storeKey
        filename
        location
      }
    }
  }
`;

export { UPDATE_FILE, UPLOAD_FILE, DELETE_FILE_BY_ID };
